import styled from "styled-components"
import { Colors } from 'styles/app-styles'
import DataTable_s from "components/table/data-table-styles"

export const TenantGroups_s = styled.div`
  .p-paginator {
    bottom: 0px;
  }
`

export const TenantGroupsTable_s = styled(DataTable_s)`
  border-spacing: 15px;

  table.p-datatable-scrollable-header-table, table.p-datatable-scrollable-body-table {
    width: auto;
  }

  table.p-datatable-scrollable-body-table {
    box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);
  }

  .p-datatable-thead > tr {
    height: 30px;
  }

  // Hide filter input row
  .p-datatable-unfrozen-view thead.p-datatable-thead > tr:last-child {
    display: none;
  }

  .systemImmutable-row {
    background: ${Colors.athensGrey} !important;
  }
  .system-row .system-disabled {
    background: ${Colors.athensGrey};
  }
`